/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

import CertificateList from './list'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Certificate Management</a></li>
									<li className="breadcrumb-item active">Certificate of Indigency (BIR-SPES)</li>
								</ol>
							</div>
							<h4 className="page-title">Certificate of Indigency (BIR-SPES)</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<CertificateList />
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
